/**
 * Checks if the current environment is production (penciltopolish.com)
 * @returns boolean indicating if running in production environment
 */
export const isProduction = (): boolean => {
  return window.location.href.includes("penciltopolish.com");
};
